/* eslint-disable import/order */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

import SelectField from '../../components/SelectField'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { changeResponsible } from '../AttendanceActions'

function ChangeResponsible({ open, row, onClose }) {
  const dispatch = useDispatch()
  const styles = filterStylesComponents()
  const attendants = useSelector(state => state.attendance.attendants)

  const [responsible, setResponsible] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (open && row) {
      const current =
        attendants?.find(a => a.id === row.userId) ||
        attendants?.find(a => a.name === row.userName) ||
        null
      setResponsible(current)
    }
  }, [open, row, attendants])

  const handleConfirm = async () => {
    if (!responsible?.id) return
    setSaving(true)
    const resp = await dispatch(changeResponsible(row.id, responsible.id))
    setSaving(false)
    if (resp?.status === 200) onClose()
  }

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      aria-labelledby="change-responsible-title"
    >
      <DialogTitle id="change-responsible-title">Trocar Atendente</DialogTitle>
      <DialogContent>
        <SelectField
          options={attendants || []}
          setForm={(name, value) => setResponsible(value)}
          data={responsible}
          name="responsible"
          variant="standard"
          label="Atendente"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          className={styles.btnSalvar}
          disabled={saving || !responsible?.id}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ChangeResponsible
